<li class="nav-item bs-dropdown bs-pl-4 bs-pr-2 d-sm-down-none user-bar-nav" placement="bottom right">
  <a class="bs-nav-link" data-toggle="dropdown" role="button" style="cursor: default;">
    <i class="fa fa-user-circle">&nbsp;</i>
    {{userDisplayName$ | async}}
  </a>
</li>
